import axios from 'axios';
import { InventoryItemActionTypes } from './';

const endpoint = `${process.env.REACT_APP_IMS_API_HOST}/inventory/items/sub`;

export function findInventoryItems(param, callback, errorCallback) {

  let { page, perPage, order, ascDesc, search, display } = param;

  if (!page) page = 1;
  if (!perPage) perPage = 50;

  const request = axios.get(`${endpoint}?page=${page}&perPage=${perPage}${order ? `&order=${order}` : ''}${ascDesc ? `&ascDesc=${ascDesc}` : ''}${search ? `&search=${search}` : ''}${display !== null && display !== undefined ? `&display=${display}` : ''}`);

  if (callback) {
      request.then((response) => callback(response));
  }

  if (errorCallback) {
      request.catch((error) => errorCallback(error));
  }

  return {
    type: InventoryItemActionTypes.FIND,
    payload : request
  };
}



// WEBPACK FOOTER //
// ./src/actions/inventoryitem.action.js